export const variants = {
    rounded: {
        table: {
            boxShadow: 'none',
            marginBottom: 0,
        },
        th: {
            textTransform: 'uppercase',
        },
        td: {
            fontSize: 'sm',
        },
        thead: {
            tr: {
                color: 'gray.600',
                backgroundColor: 'gray.50',
            },
        },
    },
};
